import React, { FC } from 'react';
import Button, { ButtonProps } from '@mui/material/Button';
import makeStyles from '@mui/styles/makeStyles';
import { theme } from 'theme';
import clsx from 'clsx';

type ChipButtonProps = {
  isActive?: boolean;
} & ButtonProps;

const useStyles = makeStyles(() => ({
  root: {
    margin: 5,
    padding: '3px 6px',
    fontSize: 14,
    fontWeight: 500,
    minWidth: 130,
    minHeight: 32,
    borderColor: theme.palette.custom.darkGrayAlt2,
    borderWidth: 2,
    borderRadius: 16,
    borderStyle: 'solid',
    opacity: 0.4,
    color: 'rgba(0, 0, 0, 0.87)',
    textTransform: 'none',
    backgroundColor: 'transparent',
    transition: 'none',
  },
  active: {
    borderColor: theme.palette.primary.main,
    borderWidth: 2,
    backgroundColor: theme.palette.primary.main,
    opacity: 1,
    color: theme.palette.custom.white,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
  },
}));

const ChipButton: FC<ChipButtonProps> = ({ isActive, children, ...props }) => {
  const classes = useStyles();

  return (
    <Button
      className={clsx(classes.root, isActive && classes.active)}
      variant={isActive ? 'contained' : 'outlined'}
      disableElevation
      disableTouchRipple
      {...props}
    >
      {children}
    </Button>
  );
};

export default ChipButton;
